import React, { useState } from 'react';
import Select from 'react-select';

export const SearchSelect = ({options, value, changeHandler}) => {
  const [selectedOption, setSelectedOption] = useState(value);
  const handleChange = (selected) => {
    setSelectedOption(selected);
    changeHandler(selected)
  };

  return (
    <Select
      value={selectedOption}
      onChange={handleChange}
      options={options}
      className='search-select'
      isSearchable
      placeholder="Промоутер"
    />
  );
}
